import { t } from 'i18n';
import moment from 'moment';

import { GLOBAL_WIDGET_NAMESPACE } from './translation';
import { KW, KWH } from './unit-measures';

export const kwYaxisLabel = KW;

export const percentageYaxisLabel = '%';

export const meterChartOptionsValues = {
  batterySoc: 'BATTERY_SOC',
  currentPower: 'P_CURRENT',
};

export const resourceLogsFilters = {
  order: 'TIMESTAMP',
  dir: 'DESC',
};

export const KPI_SEARCH_ENERGY = 'ENERGY';
export const KPI_SEARCH_COST = 'COST';
export const KPI_SEARCH_TOTAL_COST = 'TOTAL_COST';
export const KPI_SEARCH_REIMBURSEMENT = 'REIMBURSEMENT';
export const KPI_SEARCH_COST_PUBLIC = 'COST_PUBLIC';
export const KPI_SEARCH_COST_PRIVATE = 'COST_PRIVATE';
export const KPI_SEARCH_SESSION = 'SESSION';
export const KPI_SEARCH_ENERGY_PRIVATE = 'ENERGY_PRIVATE';
export const KPI_SEARCH_ENERGY_PUBLIC = 'ENERGY_PUBLIC';
export const KPI_SEARCH_ENERGY_DOMESTIC = 'ENERGY_DOMESTIC';
export const KPI_SEARCH_PUBLIC_PRIVATE_ENERGY = 'ENERGY_PUBLIC_PRIVATE';
export const KPI_SEARCH_CO2 = 'CO2';
export const KPI_SEARCH_CO2_PRIVATE = 'CO2_PRIVATE';
export const KPI_SEARCH_CO2_PUBLIC = 'CO2_PUBLIC';
export const KPI_SEARCH_CO2_DOMESTIC = 'CO2_DOMESTIC';
export const KPI_SEARCH_TREE = 'TREE';
export const KPI_SEARCH_TREE_PRIVATE = 'TREE_PRIVATE';
export const KPI_SEARCH_TREE_PUBLIC = 'TREE_PUBLIC';
export const KPI_SEARCH_TREE_DOMESTIC = 'TREE_DOMESTIC';

export const DRIVER_ENUM = 'DRIVER';
export const VEHICLE_ENUM = 'VEHICLE';
export const OPERATOR_ENUM = 'OPERATOR';

export const eurWidgetConf = {
  title: '€',
  id: 'y',
  position: 'left',
};

export const percentageWidgetConfLeft = {
  title: '%',
  id: 'y',
  position: 'left',
};

export const percentageWidgetConf = {
  title: '%',
  id: '%',
  position: 'right',
  drawOnChartArea: false,
  min: 0,
  max: 100,
};

export const energyWidgetConf = {
  title: KWH,
  id: 'y',
  position: 'left',
};

export const latestUpdateLabelKpi = (value, country) => (value
  ? moment.unix(Number(value) / 1000)
    .local()
    .locale(country)
    .format('HH:mm DD/MM/YY') : '');

export const loadingLabel = () => t(`${GLOBAL_WIDGET_NAMESPACE}.loading`);

export const ENERGY_REWARDS_WIDGET = 'energyCommunityRewardsWidget';

export const ENERGY_PRODUCTION_WIDGET = 'energyProductionWidget';

export const ENERGY_PERFORMANCE_WIDGET = 'energyPerformanceWidget';

export const ENERGY_RANKING_WIDGET = 'energyRankingWidget';

export const SQUARE_LINE_CHART = 'squareLine';

export const CUSTOM_DOUGHNUT_TYPE = 'customDoughnut';

export const BAR_TYPE = 'bar';
